module.exports = __webpack_public_path__ + "img/shopingTips.c6fa984f.png";